module.exports = __webpack_public_path__ + "static/st-1-phishing-hover-e036299272a9a0a542ef3525f53ddd55.jpg";